import axios from "axios";
import router from "@/router";


//生产环境
const $baseUrl = 'https://apidis.xiangchao.ink/server';

//测试环境
// const $baseUrl = 'http://192.168.1.103:8061/server';

const initAxios = axios.create({
    timeout: 1800000,//数据响应过期时间
    baseURL: $baseUrl
})

//请求拦截器
initAxios.interceptors.request.use((config) => {
    //在发送之前做点什么
    //获取token
    const token = localStorage.getItem('token');
    if (token) {
        if (config.method === 'post') {
            config.data.token = token;
        } else {
            config.params.token = token;
        }
    }


    return config
}, (error) => {
    //对请求错误做点什么
    console.log(error)
    return error
})

//响应拦截器
initAxios.interceptors.response.use((response) => {
    if (response.status === 200 ) {
        if (response.data.code == 401 || response.data.code == 402) {
            //token失效
            localStorage.removeItem('token');

            //获取当前页面
            const currentPath = router.currentRoute.value.fullPath;   //跳转登录页面
            //验证字段是否包含临时号信息
            if (currentPath.indexOf('temporary') != -1) {
                router.push({
                    path: '/temporary/user/login'
                })

                return {code: 401,msg: '登录失效，请重新登录'};
            }

            router.push({
                path: '/login'
            })
            return {code: 401,msg: '登录失效，请重新登录'};
        }

        return response.data
    } else {
        return {resultCode: -1}
    }
},(error) => {
    //对响应错误做点什么

    console.log('请求错误');
    console.log(error)
    console.log(error.response)

    return error
})
//导出
export default () => initAxios